import { connect } from 'react-redux'
import {
  addPaymentMethod,
  fetchPaymentMethods,
  fetchServicePricingDiscount,
  generateDefaultServicePricingDiscount,
  updatePaymentMethods,
  updateServicePricingDiscount
} from 'src/state/actions/services'
import { IPaymentMethods } from 'src/types/payment-methods'
import ServicePricingBreakdown from '../../components/services/edit/ServicePricingBreakdown'
import {
  createServicePricingItem,
  fetchServicePricingItem,
  updateServicePricingItem
} from '../../state/actions/services/servicePricing'
import { getServicePricing } from '../../state/reducers/services/servicePricing'
import { IStoreState } from '../../types/index'
import {
  IServicePricingCreateDTO,
  IServicePricingModel,
  IServicePricingUpdateDTO,
  IServicePricingUpdatePayload
} from '../../types/service-pricing'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const { servicePricingDiscount } = state.service
  const serviceId = state.service.metadata.edit.serviceId
  const orgId = state.organizations.currentOrgId
  let pricing: IServicePricingModel | undefined

  if (serviceId && orgId) {
    pricing = getServicePricing(state, serviceId, orgId)
  }

  return {
    serviceId,
    servicePricingDiscount,
    orgId,
    pricing,
    formRef: ownProps.formRef,
    paymentMethods: state.service.paymentMethods,
    onCreateServiceCompleted: ownProps.onCreateServiceCompleted
  }
}
const mapDispatchToProps = (dispatch: any): any => {
  return {
    onComponentMount: (serviceId: string, orgId: string) => {
      dispatch(fetchServicePricingItem(serviceId, orgId))
      dispatch(fetchPaymentMethods(serviceId))
    },
    updatePricing: (pricing: IServicePricingUpdateDTO, isServicePricingDiscountEnable: boolean) => {
      if (isServicePricingDiscountEnable) {
        dispatch(generateDefaultServicePricingDiscount(pricing.serviceId))
      }
      return dispatch(updateServicePricingItem(pricing))
    },
    createPricing: (pricing: IServicePricingCreateDTO) => {
      return dispatch(createServicePricingItem(pricing))
    },
    updatePaymentMethods: (serviceId: string, paymentMethods: IPaymentMethods[]) => {
      return dispatch(updatePaymentMethods(serviceId, paymentMethods))
    },
    addPaymentMethod: (serviceId: string, paymentMethod: IPaymentMethods[]) => {
      return dispatch(addPaymentMethod(serviceId, paymentMethod))
    },
    fetchServicePricingDiscount: (serviceId: string) => {
      return dispatch(fetchServicePricingDiscount(serviceId))
    },
    updateServicePricingDiscounts: (serviceId: string, payload: IServicePricingUpdatePayload) => {
      return dispatch(updateServicePricingDiscount(serviceId, payload))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServicePricingBreakdown)



// WEBPACK FOOTER //
// ./src/containers/services/ServicePricingBreakdown.ts